<template>
  <button
    :aria-label="'Search'"
    @click="click"
    :class="[
      'focus:outline-none focus-visible:outline-[revert]  focus-visible:outline-offset-8 rounded-sm',
      props.themeType === 'dark' ? 'text-white' : 'text-aubergine',
      props.classes,
    ]"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      :class="[
        props.themeType === 'dark' ? 'stroke-white' : 'stroke-aubergine',
      ]"
    >
      <path d="M15.0522 15.3658L22 22.3136" stroke-width="3" />
      <circle
        cx="10.1865"
        cy="10.5001"
        r="7.5"
        transform="rotate(-90 10.1865 10.5001)"
        stroke-width="3"
      />
    </svg>
  </button>
</template>
<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  classes?: string;
  themeType: 'dark' | 'light';
}>();

type Emits = {
  (e: "click"): void;
};

const emit = defineEmits<Emits>();

const click = () => {
  emit("click");
};

const buttonClasses = computed(() => [
  'focus:outline-none',
  props.themeType === 'dark' ? 'text-white' : 'text-aubergine',
  props.classes,
]);

const svgClasses = computed(() => [
  props.themeType === 'dark' ? 'stroke-white' : 'stroke-aubergine',
]);
</script>